<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.connectivity.details.equipment.add-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <gdp-add-edit-connectivity-equipment-form (onSubmit)="createEquipment($event)" [loading]="loading"
        [company]="company" [connectionId]="connectionId">
      </gdp-add-edit-connectivity-equipment-form>
    </div>
  </div>
</div>